export const mockBoardingEnabledRes = {
  boardingEnabled: 'true'
};

export default mockBoardingEnabledRes;
